// userSlice.js
import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    isAuthenticated: false, // Default: user is not logged in
    user: null,
  },
  reducers: {
    setLogin(state, action) {
      state.isAuthenticated = true;
      state.user = action.payload;
    },
    setUserProfile(state, action) {
      state.user = action.payload;
    },
    logout(state) {
      state.isAuthenticated = false;
      state.user = null;
      localStorage.removeItem("token")
      localStorage.removeItem("token_expiry")
    },
  },
});

export const { setLogin, logout,setUserProfile } = userSlice.actions;
export default userSlice.reducer;